export * from './window-type-8.component';